import React from "react"

interface ReadOnlyContextInterface {
    isReadOnly?: boolean
}

export const ReadOnlyContext = React.createContext<ReadOnlyContextInterface>({})
